export const SUPPORT_URLS = Object.freeze({
  createTicket: '/requests/new',
  createHeatmapTicket: '/requests/new?ticket_form_id=360000396054',
  createCSMTicket: '/requests/new?ticket_form_id=360000665794&insightsapp',
  createBillingPaymentTicket: '/requests/new?ticket_form_id=360000390393&insightsapp',
  getStarted: '/articles/360049416814',
  /**
   * @deprecated use {@see SUPPORT_URLS.comparePlans}
   */
  comparePricing: '/sections/360003795554-Plans',
  comparePlans: '/sections/360003795554-Plans',
  doesHotjarTrackAllVisitors: '/articles/115011624047',
  newTicketHelp: '/articles/360052491234',
  plansAndBillingHelp: '/categories/360001640813',
  whatAreSnapshots: '/articles/115011656367',
  clickedElementFilter: '/articles/8917152574743',
});

export const SUPPORT_ACCOUNT_EMAIL = 'support@hotjar.com' as const;
